export default "__VITE_ASSET__BV9AogbA__"